import { TemplateSmsRawItem } from "./constants";

export const actionTypes = {
  GET_TEMPLATE_SMS_OPERATIONS: "GET_TEMPLATE_SMS_OPERATIONS",
  GET_TEMPLATE_SMS_OPERATIONS_SUCCESS: "GET_TEMPLATE_SMS_OPERATIONS_SUCCESS",
  GET_TEMPLATE_SMS_OPERATIONS_FAILURE: "GET_TEMPLATE_SMS_OPERATIONS_FAILURE",

  UPDATE_TEMPLATE_SMS_OPERATION: "UPDATE_TEMPLATE_SMS_OPERATION",
  UPDATE_TEMPLATE_SMS_OPERATION_SUCCESS:
    "UPDATE_TEMPLATE_SMS_OPERATION_SUCCESS",
  UPDATE_TEMPLATE_SMS_OPERATION_FAILURE:
    "UPDATE_TEMPLATE_SMS_OPERATION_FAILURE",

  SELECT_OPERATION: "SELECT_OPERATION",
};

export const getTemplateSmsAction = () => ({
  type: actionTypes.GET_TEMPLATE_SMS_OPERATIONS,
});

export const getTemplateSmsActionSuccess = (payload: TemplateSmsRawItem[]) => ({
  type: actionTypes.GET_TEMPLATE_SMS_OPERATIONS_SUCCESS,
  payload,
});

export const getTemplateSmsActionFailure = (error: any) => ({
  type: actionTypes.GET_TEMPLATE_SMS_OPERATIONS_FAILURE,
  error,
});

export const selectOperationAction = (payload: TemplateSmsRawItem) => ({
  type: actionTypes.SELECT_OPERATION,
  payload,
});

export const updateTemplateSmsAction = (payload: TemplateSmsRawItem) => ({
  type: actionTypes.UPDATE_TEMPLATE_SMS_OPERATION,
  payload,
});

export const updateTemplateSmsActionSuccess = () => ({
  type: actionTypes.UPDATE_TEMPLATE_SMS_OPERATION_SUCCESS,
});

export const updateTemplateSmsActionFailure = (error: any) => ({
  type: actionTypes.UPDATE_TEMPLATE_SMS_OPERATION_FAILURE,
  error,
});
